import React, { Suspense, useState } from 'react';
import Phone from '@material-ui/icons/Phone';

import { LegalLinks } from 'app/components/LegalLinks';
import { FormFooter } from 'app/components/FormFooter';
import { NewButton } from 'app/components/NewButton';
import { FirstStepEnum, LabelEnum } from 'app/shared/enums';
import { mainPhoneNumber } from 'app/services/env.service';
import { getPhoneNumberHref } from 'app/shared/helpers/getPhoneNumberHref';
import lazyWithReload from 'app/shared/helpers/lazyWithReload';
import retryImport from 'app/shared/helpers/retryImport';

import { CalculationFirstStepPlaceholderContent } from 'app/components/CalculationFirstStepPlaceholderContent';

import { useStyles } from './CalculationFirstStepPlaceholder.styles';

const CallMeBackModal = lazyWithReload(() =>
  retryImport(() => import('app/components/CallMeBackModal/CallMeBackModal'))
);

export default function CalculationFirstStepPlaceholder() {
  const classes = useStyles();
  const [isCallMeBackModalOpened, setIsCallMeBackModalOpened] = useState(false);

  return (
    <div className={classes.root}>
      <div className={classes.formContainer}>
        <div className={classes.formWrapper}>
          <CalculationFirstStepPlaceholderContent />
        </div>
      </div>
      <div className={classes.legalLinks}>
        <LegalLinks />
      </div>
      <div className={classes.formFooter}>
        <FormFooter />
      </div>
      <div className={classes.helpSection}>
        <span className={classes.helpSectionTitle}>
          {FirstStepEnum.FreeCall}
        </span>
        <div className={classes.callMeBackButtonContainer}>
          <NewButton
            className={classes.callMeBackButton}
            color={'primary'}
            variant={'outlined'}
            title={LabelEnum.RequestForCallback}
            onClick={() => setIsCallMeBackModalOpened(true)}
            noWrap
          />
          {isCallMeBackModalOpened && (
            <Suspense fallback={null}>
              <CallMeBackModal
                onClose={() => setIsCallMeBackModalOpened(false)}
              />
            </Suspense>
          )}
          <div className={classes.callMeBackButtonText}>
            <Phone className={classes.icon} />

            {mainPhoneNumber && (
              <a
                className={classes.link}
                href={getPhoneNumberHref(mainPhoneNumber)}
              >
                {mainPhoneNumber}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
